<template>
  <div>
    <div class="document">
      <img src="../../../assets/img/logo/PinkNannies-RGB-Horizontal.svg" alt="" class="center" style="width: 210px; padding-bottom: 30px;">
      <h3 style="text-align: center;">Distracted Driving Policy</h3>
      <hr>
      <p>PINK Nannies is committed to ending the epidemic of distracted driving, and has created the following rules, which apply to any nanny operating their personal vehicle or a family’s vehicle while children are in the car:</p><p>• Nannies may not use a hand-held cell phone while operating a vehicle – whether the vehicle is in motion or stopped at a traffic light. This includes, but is not limited to, adjusting a Global Positioning System (GPS), answering or making phone calls, engaging in phone conversations, and reading or responding to emails, instant messages, and text messages.</p><p>• If a nanny needs to use their phone, they must pull over safely to the side of the road or another safe location.</p><p>• Additionally, nannies are required to:</p><p>o Turn cell phones off or put them on silent or vibrate before starting the car.</p><p>o Consider modifying voice mail greetings to indicate that you are unavailable to answer calls or return messages while driving.</p><p>o Inform friends and family of this policy as an explanation of why calls may not be returned immediately.</p><p>Violations of this policy will be considered serious and may result in the imposition of discipline up to and including termination. I acknowledge that I have received a written copy of the Distracted Driving Policy, that I fully understand the terms of this policy, that I agree to abide by these terms, and that I am willing to accept the consequences of failing to follow the policy.</p>
      <hr>
      <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
      <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
      <h4 v-if="signature" style="font-family: 'Arizonia'; text-transform: none;">{{ signature }}</h4>
      <h4 v-if="!signature">___________________</h4>
      <p v-if="document.status == 'Signed'">{{ document.signing_name }}</p>
      <div v-if="!document.signing_name">
        <input type="text" class="form-control" v-model="signature" style="max-width: 500px;">
        <label v-if="!signature" class="mt-1">Please type your name.</label>
        <div>
          <button v-if="!signature" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
          <button v-if="signature" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
        </div>
      </div>
      <!-- <p>{{ document }}</p> -->
      <!-- <button @click="deleteDocument()" class="mylisting-button danger-button">Delete</button> -->
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['document'],
  data() {
    return {
      signature: '',
    }
  },
  created() {
    this.signature = this.document.signing_name
  },
  methods: {
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteDocument() {
      axios.delete(`/api/documents/${this.document.id}/`)
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/candidates/documents/DistractedDriving.vue